// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3-xHo","inputWrap":"styles_inputWrap__2ZYAq","input":"styles_input__3xLAx"};